import {FC, useState} from 'react'
import {SubscriptionPlanDialog} from '../../../../components/SubscriptionPlanDialog'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../../../../setup'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import {useQueryClient} from 'react-query'
import {useMutation} from 'react-query'
import {Loader} from '../../../../../../services/Loader'
import {handleNotificationWithToastify} from '../../../../../../services/Functional'
import {patchRequest} from './../../../../../../../setup/redux/common/cruds'
import {ID} from '../../../../../../../_metronic/helpers'

type Props = {
  row: any
}

const AssignPlanCell: FC<Props> = ({row}) => {
  const {query} = useQueryResponse()
  const queryClient = useQueryClient()
  const module = 'subscription_plans'
  const [loading, setLoading] = useState<boolean>(false)
  const [isSubscriptionPlanDialog, setIsSubscriptionPlanDialog] = useState(false)
  const [isEditPlan, setIsEditPlan] = useState(false)
  const [selectedSubscriptionType, setSelectedSubscriptionType] = useState<string>('monthly')
  const {selectedPlanId}: any = useSelector<RootState>(
    (state) => ({
      selectedPlanId: state.subscriptionPlans.selectedPlanId,
    }),
    shallowEqual
  )

  const openSubscriptionPlanDialog = () => {
    setIsSubscriptionPlanDialog(true)
    setIsEditPlan(false)
  }

  const openSubscriptionPlanEditDialog = (selectId: ID) => {
    setIsSubscriptionPlanDialog(true)
    setIsEditPlan(true)
  }

  const closeSubscriptionPlanDialog = () => {
    setIsSubscriptionPlanDialog(false)
  }

  const handleSubscriptionTypeChange = (type: string) => {
    setSelectedSubscriptionType(type)
  }

  // Assign subsription plan

  const onClickSubmit = async () => {
    await handleSubmit(onClickAssignItem, setLoading)
  }

  const obj = {
    subscription_plan_id: selectedPlanId,
    company_request_id: row.id,
    subscription_type: selectedSubscriptionType,
    ...(isEditPlan ? {request_type: row?.request_type} : {}),
  }

  const handleSubmit = async (onClickAssignItem: any, setLoading: any) => {
    setLoading(true)
    await onClickAssignItem.mutateAsync()
  }

  const onClickAssignItem = useMutation(
    () =>
      patchRequest(`${process.env.REACT_APP_API_BASE_URL}inspection_companies/assign/plan`, obj),
    {
      onSuccess: async (response) => {
        await queryClient.invalidateQueries([`${module}-${query}`])
        setIsSubscriptionPlanDialog(false)
        handleNotificationWithToastify(response.data)
        setLoading(false)
      },
      onError: () => {
        setLoading(false)
      },
    }
  )

  return (
    <>
      {loading && <Loader />}
      <div className='d-flex justify-content-center flex-column align-items-end'>
        {(row?.plans &&
          row.plans.length > 0 &&
          row?.plans[0]?.subscription?.type !== 'enterprise') ||
        (row?.request_type === 'enterprise_upgrade' &&
          row?.upgrade_subscription_type !== 'enterprise') ? (
          <>
            <span className='text-end'>
              {row?.request_type === 'enterprise_upgrade'
                ? row?.upgrade_subscription_name || 'Enterprise Upgrade'
                : row?.plans[0]?.subscription?.name}
            </span>
            <a
              onClick={() => {
                if (row?.request_type === 'enterprise_upgrade') {
                  openSubscriptionPlanEditDialog(row?.upgrade_subscription_id)
                } else {
                  openSubscriptionPlanEditDialog(row?.plans[0]?.subscription?.id)
                }
              }}
              className='link-primary'
            >
              <u>Change Plan</u>
            </a>
          </>
        ) : (
          <a onClick={openSubscriptionPlanDialog} className='link-primary'>
            <u>Assign Plan</u>
          </a>
        )}
      </div>
      {isSubscriptionPlanDialog && (
        <SubscriptionPlanDialog
          row={row}
          isEditPlan={isEditPlan}
          onClose={closeSubscriptionPlanDialog}
          isSubscriptionPlanDialog={isSubscriptionPlanDialog}
          onClickSubmit={onClickSubmit}
          onSubscriptionTypeChange={handleSubscriptionTypeChange}
        />
      )}
    </>
  )
}

export {AssignPlanCell}
